// src/components/Logout.js
import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import UserContext from '../context/UserContext';

function Logout() {
  const navigate = useNavigate();
  const { setUser } = useContext(UserContext);

  useEffect(() => {
    localStorage.removeItem('token');
    setUser(null);
    navigate('/');
  }, [navigate, setUser]);

  return null;
}

export default Logout;